import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import download from "../../../../assets/img/svg/DownloadIcon.svg";
import { Tabs, Tab, AppBar, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import del from '../../../../assets/img/svg/Del.svg'
import { useNavigate } from "react-router-dom";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import styles from "../../../../assets/jss/customStyle";
import $ from "jquery";
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import image from '../../../../assets/img/svg/Image.svg';
import Ship from "../../../../assets/img/svg/Ship.svg";
import Close from "@material-ui/icons/Close";
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import moment from "moment";
import { getSettingsFormat } from "../../../../actions/SettingsAction";
import active from '../../../../assets/img/svg/active.svg';
import deactive from '../../../../assets/img/svg/deactive.svg';
import InnerImageZoom from "react-inner-image-zoom";
import { formatRelativeWithOptions } from "date-fns/fp";
import { trainingStatus, yardOwnerRole, yardTrainingPlan, yardTrainingPlanEditActual } from "../../../common/commonJson";

class ViewActualDate extends Component {
    constructor(props) {
        super(props)
        this.inputFile = React.createRef();
        this.state = {
            isMobile: false,
            value: 0,
            isView: false,
            ActualDateError: false,
            DocsError: false,
            fileUrl: "",
            fileName: "",
            DelIndex: 0,
            filename: "",
            index: 0,
            awsname: "",
            IfdeletePost: {
                "PlannedDate": null,
                "ActualDate": null,
                "Month": "",
                "Id": 0,
                "TrainingTitle": "",
                "TrainingId": 0,
                "Modify": localStorage.getItem("UserRoles")
            },
            addData: {
                "PlannedDate": null,
                "ActualDate": null,
                "Month": "",
                "Id": 0,
                "TrainingTitle": "",
                "TrainingId": 0,
                "Comments": "",
                "Modify": ""
            },
            Docs: [],

            ProjectId: 0,
            YardId: 0,
            TrainingDateId: 0,
            YardTraining: false,
            actionData: {},
            UserRole: "",
            DelId: {},
            PlannedDates: [],
            ObjectKey: [],
            isViewTraining: false,
        }
    }

    componentDidMount() {
        window.location.pathname.includes(yardTrainingPlanEditActual) ? this.setState({ isViewTraining: true }) : this.setState({ isViewTraining: false });
        (localStorage.getItem("UserRoles") == "Admin" || localStorage.getItem("UserRoles") == yardOwnerRole) ? this.setState({ isView: false }) : this.setState({ isView: true });
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.YardId = localStorage.getItem("YardId");
        this.state.TrainingDateId = parseInt(localStorage.getItem("TrainingPlanEditId"));
        this.state.YardTraining = localStorage.getItem("YardTraining") == "true" ? true : false;
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.getedittpydocinfo(this.state.TrainingDateId)
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#TrainingPlan1 .MuiListItemText-primary").removeClass("spanTopBar");
        $("#YTrainingPlan .MuiListItemText-primary").removeClass("fw-bolder");
        $("#TrainingPlan").addClass("d-none");
        $("#TrainingPlan").removeClass("d-block");
        $("#YardTrainingPlan").removeClass("active-color");
        $("#TrainingPlan").removeClass("fw-bolder");
    }

    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            if (this.state.isViewTraining) {
                this.props.navigate("/sidebaryarddocument");
            }
            else {
                this.props.navigate("/sidebar");
            }
        }
    };

    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        if (this.state.isViewTraining) {
            this.props.navigate("/sidebaryarddocument");
        }
        else {
            this.props.navigate("/sidebar");
        }
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#PLAN1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Trainingplan1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Trainingplan").removeClass("d-none");
        $("#Trainingplan").addClass("d-block");
        $("#TPL").addClass("active-color");
        $("#TPT").addClass("fw-bolder");
    };

    AttachFiles = (e) => {
        this.inputFile.current.click();
    };

    UploadFile = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        let data = [];

        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                FileSize: a.size,
                check: false,
                fdata: a,
            }
            data.push(upload);
            this.state.Docs = data;
            this.setState({})
        })
    };

    OpenPopup = (i) => {
        this.state.delindex = i;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }

    DeleteItem = () => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (this.state.Docs[0]?.ObjectKey) {
            this.state.ObjectKey.push(this.state.Docs[0]?.ObjectKey)
        }
        this.state.Docs = [];
        this.setState({})
        window.$("#deletepopup").modal("hide");
    }

    EditCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("")
        window.$("#cancelpopup").modal("hide")
    };

    OpenCancel = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show")
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            if (this.state.isViewTraining) {
                this.props.navigate(yardTrainingPlan);
            }
            else {
                this.props.navigate(trainingStatus);
            }
        }
    }

    getedittpydocinfo = (id) => {
        let apiUrl = API.GET_YARDTRAININGPLAN + id + '/actualdate';
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    // response.data?.PlannedDate?.push({
                    //     "Id": 0,
                    //     "Date": ""
                    // })
                    this.setState({
                        actionData: response.data
                    })
                    if (response?.data?.Attachments?.length > 0) {
                        this.state.Docs = response.data?.Attachments
                    }
                    this.setState({})
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    EditSave = () => {
        if (!this.state.Docs[0]?.ObjectKey && this.state.Docs?.length > 0) {
            let formData = new FormData()
            formData.append("attachments", this.state.Docs[0]?.fdata)
            this.AddAttachments(formData)
        } else {
            let data = {
                "Comments": this.state.actionData?.Comments,
                "ActualDate": this.state.actionData?.ActualDate,
                "Attachments": this.state.Docs?.length > 0 ? this.state.actionData?.Attachments : []
            }
            this.put_data(data, this.state.actionData?.TrainingId, this.state?.actionData?.PlannedActualId);
        }
        if (this.state.ObjectKey?.length > 0) {
            this.delete_attachments(this.state.ObjectKey);
        }
    }

    delete_attachments = (data) => {
        let apiUrl = API.DELETE_ATTACHMENTS;
        axios({
            method: "DELETE",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    AddAttachments = (formData) => {
        let apiUrl = API.POST_ATTACHMENTS + 'TrainingPlan';
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: formData,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    let data = {
                        "Comments": this.state.actionData?.Comments,
                        "ActualDate": this.state.actionData?.ActualDate,
                        "Attachments": response.data
                    }
                    this.put_data(data, this.state.actionData?.TrainingId, this.state?.actionData?.PlannedActualId);
                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {
                }
            });
    }

    put_data = (data, Id, planId) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        let apiUrl = API.GET_YARDTRAININGPLAN + Id + '/actualTraining/' + planId;
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/trainingstatus");
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    handleInputChange = (e, str) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.actionData[str] = e.target.value;
        this.setState({})
    }

    handleDelete = (ind, id) => {
        window.$("#deletepopupactual").modal("show");
        this.state.DelIndex = ind;
        this.state.DelId = id;
        this.setState({})
    }

    render() {
        let { classes, menuToggle } = this.props;
        const { isView, isViewTraining } = this.state;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"PLAN" + "1"} className='  textNaviIcon' primary={isViewTraining ? "Yard Documents" : "Daily Tasks"} />
                                            <NavigateNextIcon id="PLAN" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5 ">
                                    <h4>{isViewTraining ? "Edit Training Plan" : "View Training Status"}</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                {!isView ? <></> : <>
                                    <td width="5%" className="border-right">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                    <td></td>
                                    <td></td>
                                    <td></td></>}
                                {this.state.value == 1 ? <>
                                    <td width="5%" className="border-right">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>

                                </> : <>
                                    {isView ? <></> : <>

                                        <td className="border-right text-center">
                                            <i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                        {/* <td className="border-right text-center">
                                            <span className={classes.button} disabled={isView ? true : false} onClick={this.EditSave} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px', opacity: isView ? '0.5' : '' }}></img>&nbsp;Save</span> </td>
                                        <td className="border-right text-center">
                                            <span className={`${classes.button}`} onClick={this.OpenCancel} style={{ minWidth: '70px' }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</span>
                                        </td> */}
                                        {/* <td className=" text-center">
                                            <span className={`${classes.button}`} disabled={isView ? true : false} style={{ minWidth: '70px' }} onClick={() => { this.OpenActualDelete() }}><img src={Delete} style={{ marginTop: '-4px', opacity: isView ? '0.5' : '' }}></img>&nbsp;Delete</span>
                                        </td> */}
                                    </>}
                                </>}
                            </tr>
                        </tbody>
                    </table>
                        : <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                    <td width="95%">
                                        {isView ? <></> : <>
                                            {this.state.value == 0 ? <>
                                                {/* <button className={classes.button} disabled={isView ? true : false} onClick={() => this.EditSave()}><img src={Save} style={{ marginTop: '-4px', opacity: isView ? '0.5' : '' }}></img>&nbsp;Save</button> */}
                                                {/* <button className={`${classes.button} pl-3`} onClick={this.OpenCancel}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button> */}
                                                {/* <button className={`${classes.button} pl-3`} disabled={isView ? true : false} onClick={() => { this.OpenActualDelete() }}><img src={Delete} style={{ marginTop: '-4px', opacity: isView ? '0.5' : '' }}></img>&nbsp;Delete</button> */}
                                            </> : <></>}
                                        </>}
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "0" : "5px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 mt-3 ml-2">{isViewTraining ? "Edit Training Plan" : "View Training Status"}</h6>}
                        <div className="row">
                            <div className={this.state.isMobile ? isView ? "row px-0 mt-n3" : "row ml-2 pr-4 mt-3" : isView ? "row pl-5 pt-2 pr-3" : "row pl-5 pt-2 pr-3"}>
                                <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-top border-left border-right border-bottom p-3"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? " border-top border-left border-right" : "col-md-2 pt-2"}`}>
                                        <label className={this.state.isMobile ? "mt-2" : "float-end text-right"}>Training Title&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12   col-lg-10 col-xl-11   ${this.state.isMobile ? "pb-2 border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 py-3"}`}>
                                        {this.state?.actionData?.TrainingTitle && this.state?.actionData?.TrainingTitle}
                                    </div>
                                </div>
                                <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                        <label className={this.state.isMobile ? "d-flex mt-2" : "float-end text-right d-flex"}>Planned Date&nbsp;:
                                        </label>
                                    </div>
                                    <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : " pb-4 col-md-4 pt-4 mt-2"}`}>
                                        <label>{this.state.actionData?.PlannedDate && moment(this.state.actionData?.PlannedDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</label>
                                    </div>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2 mt-2"}`}>
                                        <label className={this.state.isMobile ? "d-flex mt-2" : "float-end d-flex text-right"}>Actual Date&nbsp;:
                                            {/* {isView ? <></> :
                                                <div className={`${classes.helperText}`}>
                                                    <div className="MuiFormHelperText-contained">*</div>
                                                </div>} */}
                                        </label>
                                    </div>
                                    <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "pb-4 col-md-4 pt-4 mt-2"}`}>
                                        <label>{this.state.actionData?.ActualDate && moment(this.state.actionData?.ActualDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</label>
                                    </div>
                                </div>
                                <div className={`row mx-0 ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 mt-2 pt-4"}`}>
                                        <label className={this.state.isMobile ? " mt-2" : "float-end m-0 text-right"}>Attachments&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4 mt-2"}`}>
                                        <a className="text-dec" target="_blank" href={this.state.actionData?.Attachments?.length > 0 && this.state.actionData?.Attachments[0]?.FileUrl}>{this.state.actionData?.Attachments?.length > 0 ? this.state.actionData?.Attachments[0]?.FileName : ""}</a><br />
                                        <label style={{ color: "#B0AAAA", fontSize: '10px' }}>{this.state.actionData?.Attachments?.length > 0 && ((this.state.actionData?.Attachments[0]?.FileSize / 1048576).toFixed(2) + " MB")}</label>
                                    </div>
                                </div>
                                {
                                    this.state.actionData?.TrainingTypeRoles?.length > 0 &&
                                    this.state.actionData?.TrainingTypeRoles?.map((role) => (
                                        <div className={`row mx-0 ${this.state.isMobile ? "" : "border-left border-right border-top border-bottom p-3"}`}>
                                            <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-top border-left border-right" : "col-md-2"}`}>
                                                <label className={this.state.isMobile ? "mt-2" : "float-end text-right"}>{role?.Type}&nbsp;:</label>
                                            </div>
                                            <div className={`col-12 col-sm-12   col-lg-10 col-xl-11   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10"}`}>
                                                {role?.Roles?.length > 0 &&
                                                    role?.Roles?.map((r) => (<>
                                                        <label className="pb-2">{r}</label> <br />
                                                    </>))
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                                <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom p-3"}`}>

                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-n4 col-md-2 mt-3"}`}>
                                        <label className={this.state.isMobile ? "mt-2" : "float-end text-right"}>Comments&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12   col-lg-10 col-xl-11   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 mt-3"}`}>
                                        <label>{this.state.actionData?.Comments}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >

                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.EditCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => { window.$("#cancelpopup").modal("hide") }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
        historyLog: state.commonReducer.historyLog || [],
    };
}

ViewActualDate.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ViewActualDate))
);
